import { render } from "./view_chat_user.vue?vue&type=template&id=6fa2552b"
import script from "./view_chat_user.vue?vue&type=script&lang=js"
export * from "./view_chat_user.vue?vue&type=script&lang=js"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__